export default __webpack_public_path__ + "static/media/finance_karier.05a8717b.png";